import Vue from "vue";

Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        // el.clickOutsideEvent = function (event) {
        //     if (!(el == event.target || el.contains(event.target))) {
        //         vnode.context[binding.expression](event);
        //     }
        // };
        // document.addEventListener('click', el.clickOutsideEvent)
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
            if (bubble || (!el.contains(e.target) && el !== e.target)) {
                binding.value(e)
            }
        };
        el.__vueClickOutside__ = handler;

        document.addEventListener('click', handler);
        document.addEventListener('touchend', handler);
    },
    unbind: function (el) {
        // document.removeEventListener('click', el.clickOutsideEvent)
        document.removeEventListener('click', el.__vueClickOutside__);
        document.removeEventListener('touchend', el.__vueClickOutside__);
        el.__vueClickOutside__ = null
    },
});
